import script from "./DocumentUploadZone.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentUploadZone.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentUploadZone.vue?vue&type=style&index=0&id=75141eed&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75141eed"]])

export default __exports__